diy.angular.registerDirective('diyfmthumbnail', ['$timeout', 'diyfmselectiondata', 'diyfmconfig',
function($timeout, diyfmselectiondata, diyfmconfig) {
    
    return {
        template: '\
            <div draggable="{{draggable}}" class="fm-thumb" \
                ng-class="{\
                    \'fm-thumb-noname\': !item.getName(),\
                    \'fm-thumb-selected\': selected,\
                    \'fm-thumb-inserted\': inserted\
            }">\
                <div class="fm-thumb-btns">\
                    <button class="fm-thumb-add ui-button">\
                        <span class="ui-icon ui-icon-add"></span>\
                    </button>\
                    <button class="fm-thumb-preview ui-button">\
                        <span class="ui-icon ui-icon-preview"></span>\
                    </button>\
                    <button class="fm-thumb-menu ui-button">\
                        <span class="ui-icon ui-icon-menu"></span>\
                    </button>\
                </div>\
                <div class="fm-thumb-img" diyfmprogress="progressConfig">\
                    <img ng-src="{{itemThumb}}" ng-style="item.getSource().getThumbStyle(item)" />\
                </div>\
                <div class="fm-thumb-name" \
                    ng-show="diyfmconfig.shouldShowFileNames()"\
                    diyfminlineedit="nameEditConfig" \
                    ng-bind-html="item.getName()" title="{{item.getName()}}"></div>\
            </div>',
        restrict: 'A',
        scope: true,
        compile: function(elem, iattr, transclude) {
            return {
                pre: function(scope, elem, iattr) {

                    scope.diyfmconfig = diyfmconfig;
                    
                    scope.$watch('item.getThumb()', function(newValue, oldValue) {
                        if (newValue) {
                            scope.itemThumb = newValue;
                        } else if (!scope.itemThumb && typeof scope.item.getUploadedThumb === 'function') {
                            var generateUploadThumbPromise = scope.item.getUploadedThumb();
                            if (generateUploadThumbPromise !== undefined) {
                                generateUploadThumbPromise.then(function(thumb) {
                                    scope.itemThumb = thumb;
                                });
                            }
                        }
                    });
                    scope.draggable = "true";
                    
                    // Firefox drag&drop issue - http://stackoverflow.com/a/21682033/1030269
                    var draggableAttributeToggle = function(enable) {
                        scope.draggable = enable ? 'true' : 'false';
                    }

                    scope.nameEditConfig = {
                        beforeStart: function() {
                            draggableAttributeToggle(false);
                        },
                        end: function(value) {
                            scope.renameItem(scope.item, value);
                            draggableAttributeToggle(true);
                        },
                        cancel: function() {
                            draggableAttributeToggle(true);
                        }
                    };
                    
                    scope.progressConfig = {
                       getter: scope.item.getUploadProgress ? function() {
                           return scope.item.getUploadProgress();
                       } : angular.noop,
                       runOnce: true
                    };
                    
                    // selection & insertion logic
                    scope.selected = diyfmselectiondata.isItemSelected(scope.item);
                    scope.inserted = diyfmselectiondata.isItemInserted(scope.item);

                    scope.$watch(diyfmselectiondata.getSelectionStateNumber, function(newValue, oldValue) {
                        if (newValue !== oldValue) {
                            scope.selected = diyfmselectiondata.isItemSelected(scope.item);
                            scope.inserted = diyfmselectiondata.isItemInserted(scope.item);
                        }
                    });

                    // Optimization: As we can potentially have thousdans of images here.
                    // For this, we watch the upload progress and do the opacity in a watch
                    // and then remove it
                    var 
                        $thumb,
                        uploadProgress = 'function' === typeof scope.item.getUploadProgress ? scope.item.getUploadProgress() : undefined
                    ;
                    
                    if(uploadProgress !== undefined && uploadProgress < 1) {
                        var removeProgressWatch = scope.$watch('item.getUploadProgress()', function(newProgress, oldProgress) {
                            // if we've got a progress event (eg. 0%, 5%, 10%, etc) 
                            if (typeof newProgress !== 'undefined') {
                                // we create the reference to the whole thumb element
                                if (!$thumb) {
                                    $thumb = jQuery(elem).find('.fm-thumb');
                                    $thumb.css('opacity', '0.5');
                                    $thumb.addClass('fm-uploading');
                                }
                                
                                // if progress reached 100%
                                if (newProgress >= 1) {
                                    setTimeout(function() {
                                        // switch back to full opacity
                                        $thumb.css('transition', 'opacity .2s');
                                        $thumb.css('opacity', '');
                                        // afterwards, remove the watch
                                        setTimeout(function() {
                                            $thumb.css('transition', '');
                                            $thumb.removeClass('fm-uploading');
                                            removeProgressWatch();
                                        }, 200);
                                    }, 200);                        
                                }
                            }
                        });
                    }
                }
            };
        }
    };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmthumbnail.js
 ** module id = 966
 ** module chunks = 0
 **/